import React, { ReactNode } from 'react';
import { Text, View, TouchableWithoutFeedback } from 'react-native';
import { Svg as SvgElement } from 'react-native-svg';
import i18n from 'i18n-js';

import { isWeb } from '@helpers';
import { font } from '@styles/fonts';
import { BottomTriangle, TopTriangle } from '@components/common/popupSvgTriangles/index';
import { Popup } from '@components/machines/components/timeline';
import { ColorFunction } from '@styles/colors/types';
import { ClearPopupTimeout, PopupConfig, PopupItemVariants, TriggerHidePopup } from '@interfaces/timeline';

const Wrapper = ({
  children,
  popupName,
  popupConfig,
  clearPopupTimeout,
  triggerHidePopup,
}: {
  children: ReactNode;
  popupName: Popup;
  popupConfig: PopupConfig<PopupItemVariants>;
  clearPopupTimeout: ClearPopupTimeout;
  triggerHidePopup: TriggerHidePopup;
}) => {
  if (isWeb) {
    return (
      <div
        onMouseOver={() => {
          clearPopupTimeout(popupName);
        }}
        onMouseOut={() => triggerHidePopup(popupName)}
        style={{
          position: 'absolute',
          zIndex: 10000000,
          top: popupConfig?.position?.top - 10,
          left: popupConfig?.position?.left,
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <View
      style={{
        position: 'absolute',
        zIndex: 10000000,
        top: popupConfig?.position?.top,
        left: popupConfig?.position?.left,
      }}
    >
      {children}
    </View>
  );
};

export default ({
  C,
  popupName,
  popupConfig,
  clearPopupTimeout,
  triggerHidePopup,
  popupWidth,
  popupHeight,
  action,
  textColor,
}: {
  C: ColorFunction;
  popupName: Popup;
  popupConfig: PopupConfig<PopupItemVariants>;
  clearPopupTimeout: ClearPopupTimeout;
  triggerHidePopup: TriggerHidePopup;
  popupWidth: number;
  popupHeight: number;
  action: any;
  textColor: string;
}) => {
  const { isBottom } = popupConfig;

  return (
    <Wrapper {...{ popupConfig, popupName, clearPopupTimeout, triggerHidePopup }}>
      <SvgElement
        height={popupHeight}
        width={popupWidth}
        style={[
          {
            filter: 'drop-shadow(0 0 30px rgba(0, 0, 0, 0.3))',
          },
          !isWeb && {
            shadowColor: '#000',
            shadowOffset: {
              width: 0,
              height: 7,
            },
            shadowOpacity: 0.43,
            shadowRadius: 9.51,
          },
        ]}
      >
        {isBottom ? (
          <TopTriangle {...{ popupConfig, popupWidth, popupHeight, C }} />
        ) : (
          <BottomTriangle {...{ popupConfig, popupWidth, popupHeight, C }} />
        )}
      </SvgElement>
      <View
        style={{
          position: 'absolute',
          width: popupWidth,
          height: popupHeight,
          top: 0,
          paddingHorizontal: 15,
        }}
      >
        <TouchableWithoutFeedback onPress={action ? action : null}>
          <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignContent: 'center' }}>
            <Text style={{ textAlign: 'center', marginTop: 10 }}>
              <Text style={[font.Body, { color: C(textColor || 'Link/Light/Primary'), marginRight: 5 }]}>
                {popupConfig?.item?.ncFileMain || popupConfig?.item?.ncFileName || popupConfig?.item?.errorText}
              </Text>
              {popupName === 'ncFileName' && popupConfig?.item?.ncFileVersionSequenceNumber != null && (
                <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>
                  {i18n.t('Version')} {popupConfig.item.ncFileVersionSequenceNumber}
                </Text>
              )}
            </Text>
          </View>
        </TouchableWithoutFeedback>
      </View>
    </Wrapper>
  );
};
